import React from 'react'

function ChatComp() {
  return (
    <div>ChatComp</div>
  )
}

export default ChatComp